import {Component, Inject, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {SafeHtml} from '@angular/platform-browser';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HtmlTemplatesService} from '../../../core/services/html-templates.service';

@Component({
  selector: 'app-data-protection-policy-modal',
  templateUrl: './data-protection-policy-modal.component.html',
  styleUrls: ['./data-protection-policy-modal.component.scss']
})
export class DataProtectionPolicyModalComponent implements OnInit {
  model$: Observable<SafeHtml>;
  accepted: boolean;

  constructor(private htmlTemplatesService: HtmlTemplatesService,
              private matDialogRef: MatDialogRef<DataProtectionPolicyModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { closeable: boolean }) {
  }

  ngOnInit() {
    this.model$ = this.htmlTemplatesService.getGdprTemplate();
  }

  acceptGdpr() {
    this.matDialogRef.close(true);
  }

  rejectGdpr() {
    this.matDialogRef.close(false);
  }

  closeModal() {
    if (this.data.closeable) {
      this.matDialogRef.close();
    }
  }

}
